import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { AppRoute } from '../../enums';
import { AuthenticationFacade } from '../auth';

export const authGuard: CanActivateFn = async (): Promise<UrlTree | boolean> => {
  const authService = inject(AuthenticationFacade);
  const navigation = inject(Router);

  // Resolve the persisted auth state instead of reading the in-memory
  // authenticationChange$ BehaviorSubject: on a full page reload the subject
  // still holds its initial `false`, which bounced deep links to Login/Dashboard.
  const isAuthenticated: boolean = await authService.isAuthenticated();

  if (!isAuthenticated) {
    return navigation.parseUrl(AppRoute.Login);
  }

  return true;
};
